import { ColDef, ValueGetterParams, CellClassParams } from 'ag-grid-community';
import { camelize } from 'helpers/syntaxHelper';
import { PreviewColumnT } from 'routes/Cellar/types';
import { previewCellStyle } from './cellStyle';

export const getPreviewColDef = (
    column: PreviewColumnT,
    type: DataTypesT,
    nbRows: number,
    setColumns: React.Dispatch<PreviewColumnT[]>,
    isNewTable: boolean,
): ColDef => ({
    field: column.label,
    sortable: true,
    resizable: true,
    minWidth: 200,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    floatingFilterComponent: 'textFloatingFilter',
    suppressFloatingFilterButton: true,
    valueGetter: (params: ValueGetterParams) =>
        params.data[camelize(column.name)].value,
    menuTabs: ['filterMenuTab', 'generalMenuTab', 'columnsMenuTab'],
    headerComponentParams: {
        columnType: type,
        previewColumn: column,
        nbRows,
        setColumns,
        isNewTable,
    },
    cellStyle: (params: CellClassParams) =>
        previewCellStyle(column, type, params),
});
